/* ============================================================
   MC PARALLAX — subtle scroll parallax for [data-mc-parallax]
   ============================================================
   Translates each element vertically based on its distance from the
   viewport center. Value of data-mc-parallax = strength (e.g. 0.9).
   Disabled under prefers-reduced-motion. Listens for scroll in the
   capture phase so it works with Horizon's inner scroll container
   (.page-wrapper), not just window.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = [];
  var ticking = false;

  function update() {
    var vh = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var speed = parseFloat(el.dataset.mcParallax) || 0.3;
      var centerOffset = (rect.top + rect.height / 2) - vh / 2;
      var ty = centerOffset * speed * -0.5;
      el.style.transform = 'translate3d(0,' + ty.toFixed(2) + 'px,0)';
    }
    ticking = false;
  }

  function onScroll(e) {
    // The capture-phase listener also receives scroll events from inner
    // scrollers (carousels, marquees — some scroll programmatically every
    // frame). Only react when the scrolling element can actually move a
    // parallax element, i.e. it contains one.
    if (e && e.target && e.target !== document && e.target.nodeType === 1) {
      var relevant = false;
      for (var i = 0; i < els.length; i++) {
        if (e.target.contains(els[i])) {
          relevant = true;
          break;
        }
      }
      if (!relevant) return;
    }
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function init() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-mc-parallax]'));
    if (!els.length) return;
    update();
  }

  // Capture phase catches scroll from any scroller (window or .page-wrapper)
  document.addEventListener('scroll', onScroll, true);
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
